export const PERKS_MODAL = {
  title: 'perks-modal-title',
  id: 'perks-modal-id',
  root: 'perks-modal'
};
